//moment and jquery loads via expose-plugin
import 'moment';
import 'jquery';
import 'jquery-migrate';
//require("jquery-migrate");

import 'bootstrap';
//import 'tempusdominus-bootstrap-4';
import 'bootstrap4-datetimepicker';
//currently supress debuging
jQuery.migrateMute = true;

